import { CLEAR_ERROR_MESSAGE, SET_ERROR_MESSAGE, SET_SETTINGS, SET_SETTINGS_ISLOADING, SET_VERSION, SET_VERSION_ISLOADING } from "../actions/application.actions";
import { IActionBase } from "../models/IActionBase";
import { IApplicationState } from "../models/IApplicationState";

export const defaultApplicationVersion: string = "";

export const applicationInitialState: IApplicationState = {
    errorMessage: '',
    settings: {
        clients: [],
        thresholdHour: 0
    },
    isLoading: false,
    applicationVersion: {
        version: defaultApplicationVersion
    },
    isVersionLoading: false,
};

function applicationReducer(state: IApplicationState = applicationInitialState, action: IActionBase): IApplicationState {
    switch (action.type) {
        case SET_ERROR_MESSAGE: {
            return { ...state, errorMessage: action.errorMessage };
        }
        case CLEAR_ERROR_MESSAGE: {
            return { ...state, errorMessage: "" };
        }
        case SET_SETTINGS_ISLOADING: {
            return {
                ...state,
                isLoading: action.isLoading
            };
        }
        case SET_SETTINGS: {
            return {
                ...state,
                settings: action.settings,
                isLoading: false
            };
        }
        case SET_VERSION_ISLOADING: {
            return {
                ...state,
                isVersionLoading: action.isVersionLoading
            };
        }
        case SET_VERSION: {
            return {
                ...state,
                applicationVersion: action.applicationVersion,
                isVersionLoading: false
            };
        }
        default:
            // Redux will call our reducer with an undefined state for the first time: https://redux.js.org/basics/reducers#handling-actions
            return state;
    }
}

export default applicationReducer;
